import { Store } from '@ngrx/store';
import { State } from '../State';
import { BaseActionTypes } from '../State/actions/base.actions';
import { AppGatewayService } from './app-gateway.service';
import {
    LedgerImportToPriceComparisonAddRequest, LedgerImportToPriceComparisonDeleteRequest,
    LedgerImportToPriceComparisonEditRequest,
} from '@dave/types';
import {
    LedgerImportToPriceComparisonEntity,
    LedgerImportToPriceComparisonEntityFromBackend,
} from '../entities/ledger-import-to-price-comparison.entity';
import { LedgerImportToPriceComparisonActionTypes } from '../State/actions/ledger-import-to-price-comparison.actions';
import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class LedgerImportToPriceComparisonDataService {
    constructor(private gatewayService: AppGatewayService, private store: Store<State>) {}

    async getLedgerImportToPriceComparisonFromLiId(id: string) {
        try {
            let res = await this.gatewayService.Request({ AccountingLedgerImportToPriceComparisonGet: { LedgerImportId: id } });
            if (Object.keys(res?.Errors || {}).length === 0) {
                return res.AccountingLedgerImportToPriceComparisonGet.ledgerImportToPriceComparisons;
            } else {
                throw res.Errors;
            }
        } catch (err) {
            this.store.dispatch(
                BaseActionTypes.ErrorAction({
                    Payload: {
                        ToasterMessage: 'Preisspiegel Abrufen fehlgeschlagen',
                        Err: err,
                    },
                }),
            );
        }
    }


    changeLedgerImportToPriceComparison(Payload: LedgerImportToPriceComparisonEditRequest): Promise<LedgerImportToPriceComparisonEntity> {
        return this.gatewayService
            .Request({ AccountingLedgerImportToPriceComparisonEdit: Payload })
            .then((res) => {
                if (Object.keys(res?.Errors || {}).length === 0) {
                    const m = LedgerImportToPriceComparisonEntityFromBackend(res.AccountingLedgerImportToPriceComparisonEdit.ledgerImportToPriceComparison);
                    this.store.dispatch(LedgerImportToPriceComparisonActionTypes.CreateSuccess({ Payload: m }));
                    return m;
                } else {
                    throw res.Errors;
                }
            })
            .catch((err) => {
                this.store.dispatch(
                    BaseActionTypes.ErrorAction({
                        Payload: {
                            ToasterMessage: 'Preisspiegel Bearbeiten fehlgeschlagen',
                            Err: err,
                        },
                    }),
                );
                return null;
            });
    }


    addLedgerImportToPriceComparison(Payload: LedgerImportToPriceComparisonAddRequest): Promise<LedgerImportToPriceComparisonEntity> {
        return this.gatewayService
            .Request({ AccountingLedgerImportToPriceComparisonAdd: Payload })
            .then((res) => {
                if (Object.keys(res?.Errors || {}).length === 0) {
                    const m = LedgerImportToPriceComparisonEntityFromBackend(res.AccountingLedgerImportToPriceComparisonAdd.ledgerImportToPriceComparison);
                    return m
                } else {
                    throw res.Errors;
                }
            })
            .catch((err) => {
                this.store.dispatch(
                    BaseActionTypes.ErrorAction({
                        Payload: {
                            ToasterMessage: 'Preisspiegel Hinzufügen fehlgeschlagen',
                            Err: err,
                        },
                    }),
                );
                return null;
            });
    }


    deleteLedgerImportToPriceComparison(Payload: LedgerImportToPriceComparisonDeleteRequest): Promise<Boolean> {
        return this.gatewayService
            .Request({ AccountingLedgerImportToPriceComparisonDelete: Payload })
            .then((res) => {
                if (Object.keys(res?.Errors || {}).length === 0) {
                    const m = res.AccountingLedgerImportToPriceComparisonDelete.Deleted;
                    return m;
                } else {
                    throw res.Errors;
                }
            })
            .catch((err) => {
                this.store.dispatch(
                    BaseActionTypes.ErrorAction({
                        Payload: {
                            ToasterMessage: 'Preisspiegel Löschen fehlgeschlagen',
                            Err: err,
                        },
                    }),
                );
                return null;
            });
    }
}
